<template>
  <vs-popup class=""
            id="popup"
            :title="form.category_id == '7' ? 'ADD NEW CARRIER TYPE' :  'APPROVE RAW MATERIAL'"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickUpdate)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full md:mb-0">
              <ValidationProvider vid="is_pest_control" name="is_pest_control" rules="" v-slot="{ errors }">
                <small class="label">Does this RM already exists in the system?</small>
                <vs-switch :default="false" v-model="form.is_exist_rm" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                  <span slot="on">Yes</span>
                  <span slot="off">No</span>
                </vs-switch>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3" v-if="form.is_exist_rm">
            <div class="vx-col md:w-full w-full">
              <ValidationProvider vid="exist_rm" name="exist_rm" rules="required" v-slot="{ errors }">
                <small class="label">Existing Raw Material</small>

                <multiselect label="company_product_code"
                             :custom-label="customLabel" :show-labels="false"
                             placeholder="Search "
                             v-model="exist_rm"
                             :options="raw_material_list"
                             :searchable="true"
                             :loading="isLoading"
                             :internal-search="false"
                             :clear-on-select="false"
                             :close-on-select="true"
                             :show-no-results="false"
                             :hide-selected="true"
                             @search-change="onSearch"
                             @select="onChangeExistRm"
                >
                  <template slot="singleLabel" slot-scope="{ option }">
                    <div class="d-center">
                      <span>PRODUCT CODE: <strong>{{ option.company_product_code || '-' }}</strong></span> <br>
                      <small>PRODUCT NAME : <strong>{{ option.company_product_name || '-' }}</strong></small> <br>
                    </div>
                  </template>
                </multiselect>

<!--                <v-select-->
<!--                  @search="onSearch"-->
<!--                  v-on:input="onChangeExistRm"-->
<!--                  :clearable="false" name="formulation_items" placeholder=""-->
<!--                  label="company_product_code" v-model="exist_rm" :reduce="option => option"-->
<!--                  :options="raw_material_list" :dir="$vs.rtl ? 'rtl' : 'ltr'">-->
<!--                  <template v-slot:no-options="{ search, searching }">-->
<!--                    <template v-if="searching">-->
<!--                      No results found for <em>{{ search }}</em-->
<!--                    >.-->
<!--                    </template>-->
<!--                    <em v-else style="opacity: 0.5">Start typing to search for a RM.</em>-->
<!--                  </template>-->
<!--                  <template slot="option" slot-scope="option">-->
<!--                    <div class="d-center">-->
<!--                      <span>PRODUCT CODE: <strong>{{ option.company_product_code || '-' }}</strong></span> <br>-->
<!--                      <small>PRODUCT NAME : <strong>{{ option.company_product_name || '-' }}</strong></small> <br>-->
<!--                    </div>-->
<!--                  </template>-->
<!--                  <template slot="selected-option" slot-scope="option">-->
<!--                    <div class="selected d-center">-->
<!--                      {{ option.category ? option.category.prefix : ' ' }}-{{ option.company_product_code || ' ' }}-->
<!--                    </div>-->
<!--                  </template>-->
<!--                </v-select>-->

                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full">
              <ValidationProvider vid="category_id" name="category_id" rules="required" v-slot="{ errors }">
                <small class="label">Category</small>
                <v-select :disabled="form.is_exist_rm" v-on:input="onChangeCategory" :filter-by="myFilter"  :clearable="false" name="category_id" placeholder="" label="prefix" v-model="form.category_id" :reduce="option => option.id" :options="categoryList" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template v-slot:option="option">
                    <span>{{option.prefix}} - {{option.description}}</span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">

            <div v-if="form.category_id === 7" class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider  vid="company_product_name" name="company_product_name" rules="required" v-slot="{ errors }">
                <small class="label">Carrier Name</small>
                <v-select :clearable="false" name="name" placeholder="" label="name"
                          v-model="form.company_product_name"
                          :reduce="option => option.name"
                          :options="carrierList" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                </v-select>
              </ValidationProvider>
            </div>

            <div v-if="form.category_id !== 7" class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider  vid="company_product_name" name="company_product_name" rules="required" v-slot="{ errors }">
                <small class="label">Company Product Name</small>
                <vs-input type="text" name="company_product_name" class="w-full" v-model="form.company_product_name" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>

          </div>

          <div class="vx-row mb-3" v-if="form.category_id === 7">
            <div class="vx-col md:w-full w-full md:mb-0">
                <small class="label">SG Weighting (per KG)</small>
                <vs-input disabled type="text" name="specific_gravity" class="w-full" v-model="pcsParams.specific_gravity"/>
            </div>
          </div>

          <vs-alert v-if="form.category_id === 7 && !pcsParams.specific_gravity" icon-pack="feather" icon="icon-info" color="danger" active="true" class="h-12">
            <small class="cursor-pointer" @click="onClickSGAdd">Please enter the Specific Gravity value on RM</small>
          </vs-alert>


          <div class="flex flex-wrap items-center justify-end">
            <vs-button :disabled="form.category_id === 7 && !pcsParams.specific_gravity" button="submit" class="ml-auto mt-2">Approve Raw Material</vs-button>
            <!--          <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>-->
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierRepository = RepositoryFactory.get('supplier')
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')
  const CarrierRepository = RepositoryFactory.get('carrier')
  const DropDownRepository = RepositoryFactory.get('drop_down')
  import Multiselect from 'vue-multiselect'
  import 'vue-multiselect/dist/vue-multiselect.min.css'

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      media: '',
      isImage: '',
      isVideo: '',
      title :'',
      nodata: false,
      isNote:'',
      note:'',
      createForm: {
        category_id: null
      },
      form: {
        is_exist_rm: false
      },
      exist_rm: null,
      categoryList: [],
      raw_material_list: [],
      sites: [],
      pcsParams: {
        specific_gravity: null
      },
      carrierList: [],
      isLoading: false,
    }
  }

export default {
  name: 'ApproveRawMaterialPopUp',
  data () {
    return initialState()
  },
  methods:{
    customLabel ({ category, company_product_code, company_product_name }) {
      return `${category.prefix}-${company_product_code} ( ${company_product_name} )`
    },
    async openPopup (id) {
      try {
        Object.assign(this.$data, initialState())
        this.$vs.loading()
        this.id = id
        await this.loadCategoryList()
        await this.fetchCarrierList()
        await this.loadData()
        this.open = true;
        this.$vs.loading.close()
      } catch (error) {
        this.$vs.loading.close()

      }
    },

    async onClickUpdate () {
      if(!this.pcsParams.specific_gravity && this.form.category_id == '7') {
        this.showErrorMessage('Please enter the Specific Gravity value on RM');
      } else {
        const vue = this;
        try {
          this.$vs.loading();
          const payload = {}
          if(this.form.is_exist_rm) {
            payload.category_id = this.form.category_id
            payload.company_product_code = this.form.company_product_code
            payload.company_product_name = this.form.company_product_name
          } else {
            payload.category_id = this.form.category_id
            payload.company_product_name = this.form.company_product_name
          }
          await SupplierRawMaterialRepository.approveRawMaterial(this.id, payload)
          this.showSuccessMessage('The selected raw material was successfully approved');
          location.reload();
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close();
      }

    },
    async loadCategoryList() {
      const {data} =  (await DropDownRepository.getRawMaterialCategoryList()).data
      this.categoryList =  data
    },
    async fetchCarrierList() {
      const {data} =  (await DropDownRepository.getRawMaterialCarrierList()).data
      this.carrierList  = data
    },
    async loadData() {
      this.$vs.loading()
      const {data} = (await SupplierRawMaterialRepository.getRawMaterialPCSParameters(this.id)).data
      this.pcsParams = data ? data : this.pcsParams
      // this.is_others_data = this.form.is_others_data
      this.$vs.loading.close()
    },
    myFilter: (option, label, search) => {
      let temp = search.toLowerCase();
      return option.name.toLowerCase().indexOf(temp) > -1 ||
        option.isd_code.toLowerCase().indexOf(temp) > -1
    },
    onChangeCategory() {
      // if (this.form.category_id == '7' && !this.pcsParams.specific_gravity) {
        // this.showErrorMessage('Please enter the Specific Gravity value on RM');
      // }
    },
    onChangeExistRm(select_data) {
      this.form.category_id = select_data.category.id
      this.form.company_product_code = select_data.company_product_code
    },
    onClickSGAdd() {
      this.open = false
      this.$parent.addSgValue()
    },
    onSearch(search) {
      if(search.length) {
        this.isLoading = true
        this.search(search, this);
      }
    },
    search: _.debounce( async (search, vm) => {
      const {data} = await SupplierRawMaterialRepository.getRawMaterialList(1, `filter[search]=${search}`, 50, '')
      vm.raw_material_list = data.data.filter((n) => {
        return !!n.company_product_code
      })
      vm.isLoading = false
    }, 350)
  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
    Multiselect
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .video-wrapper {
    width: 100%;
    height: 100%;
  }

  .video-wrapper video {
    object-fit: cover;
    width: 100%;
    height: 100%;

  }
  .image-wrapper {
    width: 100%;
    height: 75%;
  }


</style>
